module.exports = __webpack_public_path__ + "static/media/S (7).b0c7d74b.jpg";